import PropTypes from 'prop-types';
import { Component } from 'react';
import dynamicallySort from '../helpers/dynamicallySort';

class AccountSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
      isSingleAccount: false,
      select: this.props.accountId,
    };
    this.getAccountList = this.getAccountList.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.getAccountList();
  }

  handleInputChange(event) {
    const [option] = event.target.selectedOptions;
    this.props.switchAccount({
      accountId: event.target.value,
      accountName: option.text,
      role: option.dataset.role,
    });
    this.props.closeModal();
  }

  getAccountList() {
    let accounts = JSON.parse(sessionStorage.getItem('accounts'));
    const accountParams = {
      headers: {
        authorization: sessionStorage.getItem('authToken'),
      },
    };

    if (accounts && accounts.length === 1) {
      this.setState({ isSingleAccount: true });
      accounts[0] = (
        <span className="byline single" key={accounts[0].id}>
          {accounts[0].name}
        </span>
      );
      this.setState({ accountList: accounts });
    } else if (accounts) {
      this.setState({ isSingleAccount: false });
      accounts = accounts.sort(dynamicallySort('name'));
      accounts = accounts.map((account) => (
        <option key={account.id} data-role={account.accountUsers.role} value={account.id}>
          {account.name}
        </option>
      ));
      this.setState({ accountList: accounts });
    } else {
      fetch(`${this.props.APIBaseURL}/accounts/search/my-access?projection=detail`, accountParams)
        .then((response) => response.json())
        .then((data) => {
          // eslint-disable-next-line no-underscore-dangle
          const { accounts: accountsList } = data._embedded;

          sessionStorage.setItem('accounts', JSON.stringify(accountsList));
          localStorage.setItem('accounts', JSON.stringify(accountsList));
          this.getAccountList();
        });
    }
  }

  render() {
    let accountSelector;
    let multiClass = 'account-selector-container';

    if (!this.state.isSingleAccount) {
      multiClass += ' multiple';
      accountSelector = (
        <select id="account-selector" name="account" onChange={this.handleInputChange} value={this.state.select}>
          {this.state.accountList}
        </select>
      );
    } else {
      accountSelector = this.state.accountList;
    }
    return (
      <div className={multiClass}>
        <span className="byline">ACCOUNT </span>
        {accountSelector}
      </div>
    );
  }
}

AccountSelector.propTypes = {
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  APIBaseURL: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  switchAccount: PropTypes.func.isRequired,
};

export default AccountSelector;
